import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const FiledRowContent = styled.div(()=>({
  flex: 3,
  width: '100%',

  '.field-label': {
    fontSize: '1rem',
    fontWeight: 'bold',
    marginBottom: 5
  },

  '.error': {
    color: `${v.textRed}`
  },

  '.warning': {
    color: 'orange'
  },

  '.field-input': {
    width: '100%'
  }

}))

export const UploadFileContainer = styled.div(()=>({

  display:'flex',
  alignItems: 'flex-start',
  width:'100%',

  '.content':{
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  },

  '.dropzoneTitle':{
    fontSize: '1.25rem',
    fontWeight: 'bold'
  },

  '.errorMessage':{
    fontSize: '1rem',
    color: `${v.textRed}`
  },

  '.dropzone':{
    width: '100%'
  }

}))

export const DropzoneContainer = styled.div(()=>({
  cursor: 'pointer',
  display: 'flex',
  background: '#FFF',
  border: 'dashed 1.5px #647d91',
  borderRadius: 5,
  padding: '20px 0px',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',

  '.textTitle': {
    fontSize: '1.25rem'
  },

  '.textTitle svg':{
    fontSize: '1rem'
  },

  '.textTitle svg path': {
    color: '#647d91'
  },

  '.buttonUI': {
    height: 35,
    background: '#EAEFF5', 
    borderRadius: 5, 
    fontSize: '1.25rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 285
  }

}))